import React from "react";
import styled from "styled-components";
import { ReactComponent as HamburgerSvg } from "../media/img/hamburger-logo.svg";

const SvgIcon = styled(HamburgerSvg)`
  width: 24px;
  height: 24px;
  cursor: pointer;
  fill: #ffffff;
  transition: all 0.3s ease;

  &:hover {
    fill: #ffffff;
    filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.5));
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const SvgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  
  @media (min-width: 769px) {
    display: none;
  }
`;

const HamburgerIcon = ({ toggleMenu }) => (
  <SvgContainer>
    <SvgIcon onClick={toggleMenu} />
  </SvgContainer>
);

export default HamburgerIcon;
